export default __webpack_public_path__ + "static/img/img_1.a4003ec.png";